export const APP_CONFIG = {
  icpNumber: '皖ICP备2024060952号-1',
  icpLink: 'https://beian.miit.gov.cn/',
  copyright: `© ${new Date().getFullYear()} Ahzm Owl. All rights reserved.`,
  companyName: '猫头鹰财报分析平台'
}
